<template>
<div class="equipmentModel">
    <div class="selectType">
        <div class="type">类型：</div>
        <div class="typeSelect">
            <el-select v-model="cloudsValue" filterable placeholder="请选择" @change="selectCloud">
                <el-option
                v-for="item in clouds"
                :key="item.id"
                :label="item.cloudName"
                :value="item.id">
                </el-option>
            </el-select>
        </div>
    </div>

    <div class="submitForm">
        <el-form ref="form" :model="form" label-width="80px">
            <div class="inputs1">
                    <el-form-item label="设备名称:" prop="deviceName"
                    :rules="{
                        required: true, message: '设备名称不能为空', trigger: 'blur'
                    }"
                    class="inputWidth1"
                    >
                        <el-select
                            v-model="form.deviceName"
                            placeholder="请选择设备名称"
                            @change="changeDeviceNames($event)"
                            :label-in-value="true"
                        >
                            <el-option
                            v-for="(item,index) in deviceNames"
                            :key="index"
                            :label="item"
                            :value="index"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                
                    <el-form-item label="设备编号:" prop="deviceTypeNo"
                        :rules="{
                            required: true, message: '设备编号不能为空', trigger: 'blur'
                        }"
                        class="inputWidth1"                            
                        >
                            <el-input v-model="form.deviceTypeNo"></el-input>
                    </el-form-item>
                    
                
            </div>
            <div class="input_btn">
                <div class="inputs2" v-for="(port,index) in devicePorts[deviceIndex]" :key="index">
                    
                        <el-form-item label="设备模型:" prop="modelId"
                            :rules="{
                                required: true, message: '设备模型不能为空', trigger: 'blur'
                            }"
                            class="inputWidth1"
                        >
                                <el-select
                                    v-model="form.modelId[index]"
                                    placeholder=""
                                    @change="changeEquips"
                                >
                                    <el-option
                                    v-for="item in equips"
                                    :key="item.id"
                                    :label="item.modelName"
                                    :value="item.id"
                                    
                                    >
                                    </el-option>
                                </el-select>
                               
                        </el-form-item>
                        <el-form-item label="设备端口:" prop="port"
                            :rules="{
                                required: true, message: '设备端口不能为空', trigger: 'blur'
                            }"
                            class="inputWidth1"
                            >
                                <el-input :v-model="form.port" :value="port" ref='clearText' id="portInput"></el-input>
                        </el-form-item>                                 
                </div>   
            </div>
            
            <el-form-item class="submitBtn">
                <el-button type="primary" @click="onSubmit('form')" size="small">提交</el-button>
            </el-form-item>
        </el-form>
    </div>

    <div class="equipmentLibrary_table">
        <div class="equipmentLibrary_tit">设备列表</div>
        <div class="table">
            <el-table :data="tableData" border style="width: 100%">
                <el-table-column prop="deviceName" label="设备名称" width="">
                </el-table-column>
                <el-table-column prop="deviceTypeNo" label="设备编号" width="">
                </el-table-column>
                <el-table-column prop="modelName" label="设备模型" width="">
                </el-table-column>
                <el-table-column prop="port" label="设备端口" width="">
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="">
                <template slot-scope="{row}">
                     <!-- slot-scope="{row}" -->
                    <el-button type="text" size="small"
                    class="edit" @click="editRow(row)">修改</el-button
                    >
                    &nbsp;&nbsp;|
                    <el-button type="text" size="small"
                    class="delete" @click="deleteRow(row)">删除</el-button
                    >
                </template>
                </el-table-column>
            </el-table>
        </div>
    </div>

    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        background
        hide-on-single-page
        :pageSize="page.pageSize"
        layout="prev, pager, next"
        :total="total"
        @current-change = "changePage"
      >
      </el-pagination>
    </div>

    <div class="editDailog">
        <el-dialog title="修改模型设备" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
            <el-form ref="form1" :model="form1" label-width="80px">   
                <el-form-item label="设备名称:" prop="deviceName"
                :rules="{
                    required: true, message: '设备名称不能为空', trigger: 'blur'
                }"
                class="inputWidth1"
                >
                    <el-select
                        v-model="form1.deviceName"
                        placeholder="请选择设备名称"
                        @change="changeDeviceNames($event)"
                        :label-in-value="true"
                    >
                        <el-option
                        v-for="(item,index) in deviceNames"
                        :key="index"
                        :label="item"
                        :value="index"
                        >
                        </el-option>
                    </el-select>
                    
                </el-form-item>
                    
                <el-form-item label="设备编号:" prop="deviceTypeNo"
                    :rules="{
                        required: true, message: '设备编号不能为空', trigger: 'blur'
                    }"
                    class="inputWidth1"    
                    >  
                    <el-input v-model="form1.deviceTypeNo"></el-input>
                </el-form-item>
                               
                <el-form-item label="设备模型:" prop="modelId"
                    :rules="{
                        required: true, message: '设备模型不能为空', trigger: 'blur'
                    }"
                    class="inputWidth1"
                >
                        <el-select
                            v-model="form1.modelId"
                            placeholder=""
                            @change="changeEquips"
                        >
                            <el-option
                            v-for="item in equips"
                            :key="item.id"
                            :label="item.modelName"
                            :value="item.id"
                            >
                            </el-option>
                        </el-select>
                </el-form-item>

                <el-form-item label="设备端口:" prop="port"
                    :rules="{
                        required: true, message: '设备端口不能为空', trigger: 'blur'
                    }"
                    class="inputWidth1"
                    >   
                    <el-input v-model="form1.port" ref='clearText'></el-input>
                </el-form-item>
                        
                <el-form-item class="submitBtn">
                    <el-button type="primary" @click="editSubmit('form1')" size="small">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</div>
</template>

<script>
import {cloudSelectInfo,modelEquip_page,add_modelEquip,delModelEquip,editModelEquip,modelManage_page,deviceInfo} from '@/api'
export default {
    data() {
      return {
          //选择
        clouds: [],
        cloudsValue: null,
        //form表单
        form: {
          deviceName: '',
          modelId: [],
          deviceTypeNo: null,
          port: [],
          modelPortDtoList: [
            {
                modelId: null,
                port: null
            }
          ],
        },
        form1: {
          deviceName: '',
          modelId: null,
          deviceTypeNo: null,
          port: null,
        },
        dialogFormVisible: false,

        //table
        tableData: [],//{deviceName:'调光灯',number: '01',model:5588996,port:'PJ998221478'}
        cloudConfigId: null,
        page: {
            pageNum: 1,
            pageSize: 5
        },
        total: 0,
        //修改
        // edit: false,
        id: '',
        //选择设备
        equips: [],
        //设备信息
        // num_ports: [
        //     {deviceTypeNo: '',
        //     portSize: []
        //     }
        // ],
        deviceNames: [],
        deviceNos: [],
        devicePorts: [],
        deviceIndex: null,
        equipIds:[]
      }  
    },
    methods: {  
        onSubmit(form) {
            this.$refs[form].validate((valid) => {
                if (valid) {
                    let arr1 = []
                    for (const item1 of this.form.port) {
                        let obj1 = {}
                        obj1.port = item1
                        arr1.push(obj1)    
                    }
                    let arr2 = []
                    for (const item2 of this.form.modelId) {
                        let obj2 = {}
                        obj2.modelId = item2
                        arr2.push(obj2)    
                    }
                    var arr = arr1.map((item,index) => {
                        return {...item, ...arr2[index]};
                    });
                    this.form.modelPortDtoList = arr
                    let cloudConfigId = this.cloudConfigId
                    add_modelEquip(cloudConfigId,this.form)
                        .then(res=>{
                            if(res.data.code === '0'){
                                this.modelEquipPage(this.cloudConfigId,this.page)
                                //清空表单数据
                                // Object.keys(this.form).forEach(
                                //     (key) => (this.form[key] = "")
                                // );
                                this.form.deviceName = ''
                                this.form.deviceTypeNo = ''
                                this.form.modelId = []
                                this.form.port = []
                                this.$refs.clearText.value =''
                                // $("#portInput").val('')
                                this.form.modelPortDtoList.forEach(item=>{
                                    item.modelId = null
                                    item.port = null
                                })
                            }                               
                        })
                }
                else {
                    this.$message.error("表单校验不通过");
                }
            })
            
            
        },
        editSubmit(form1){
            this.$refs[form1].validate((valid) => {
                if (valid) {
                    let cloudConfigId = this.cloudConfigId
                        let id = this.id
                        let modelId = this.form1.modelId
                        let port = this.form1.port 
                        editModelEquip(cloudConfigId,modelId,port,id)
                            .then(res=>{
                                if(res.data.code === '0'){
                                    this.dialogFormVisible = false
                                    this.modelEquipPage(this.cloudConfigId,this.page)
                                    //清空表单数据
                                    // Object.keys(this.form).forEach(
                                    //     (key) => (this.form[key] = "")
                                    // );
                                    this.form.deviceName = ''
                                    this.form.deviceTypeNo = ''
                                    this.form.modelPortDtoList.forEach(item=>{
                                        item.modelId = null
                                        item.port = null
                                    })
                                    this.modelId = ''
                                    this.port = ''
                                    this.id = ""
                                } 
                            })
                }
                else {
                    this.$message.error("表单校验不通过");
                }
            })
        },
        //获得云id
        cloudSelect() {
            cloudSelectInfo().then((res) => {
                this.clouds = res.data.data;
                this.cloudsValue = this.clouds[1].cloudName
                this.cloudConfigId = this.clouds[1].id
                //表格数据
                this.modelEquipPage(this.cloudConfigId,this.page)
                //设备信息
                this.deviceInfo() 
                //模型管理的设备模型
                this.modelManagePage(this.cloudConfigId) 
                res.data.data.forEach(cloud=>{
                    // this.cloudConfigId.push(cloud.id)
                })
            });
        },
        //下拉选择云服务
        selectCloud(event){
            this.cloudConfigId = event
            this.modelEquipPage(this.cloudConfigId,this.page) 
            //模型管理的设备模型
            this.modelManagePage(this.cloudConfigId)   
            //设备信息
            this.deviceInfo()     
        },
        //表格数据
        modelEquipPage(cloudConfigId,pageList){
            let id = cloudConfigId
            let page = pageList
            modelEquip_page(id,page)
            .then(res=>{
                this.tableData = res.data.data
                this.total = res.data.count
            })
        },
        //删除
        deleteRow(row){
            if (row && row.id) {
                //提示信息是否永久删除
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                //调用删除请求
                    delModelEquip(this.cloudConfigId,row.id)
                        .then((res) => {
                            if (res.data.code === '0') {
                                this.$message.success("删除成功");
                                //更新表格
                                this.modelEquipPage(this.cloudConfigId,this.page);
                            } else {
                                this.$message.warning("删除失败");
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                            this.$message.error("删除出错");
                        });
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
                });  
            }else{
                this.$message.error("没有row数据")
                return
            }
        },
        //修改
        editRow(row){
            this.dialogFormVisible = true
            this.form1.modelId = row.modelId
            this.form1.port = row.port
            this.form1.deviceName = row.deviceName
            this.form1.deviceTypeNo = row.deviceTypeNo
            this.id = row.id
        },
        //改变分页
        changePage(page){
            this.page.pageNum = page
            this.modelEquipPage(this.cloudConfigId,this.page)
        },
        //增加删除设备模型/端口
        addItem () {
            this.form.modelPortDtoList.push({
                modelId: null,
                port: null
            })
        },
        deleteItem (item, index) {
            this.form.modelPortDtoList.splice(index, 1)
        },

        //模型管理的设备模型
        modelManagePage(id){
            let cloudConfigId = id
            modelManage_page(cloudConfigId).then(res=>{
                res.data.data.forEach(item=>{
                    let equip = {}
                    equip.id = item.id
                    equip.modelName = item.modelName
                    this.equips.push(equip)
                })
                this.equips.map(val=>{
                    this.equipIds.push(val.id)
                }) 
            })
        },
        //选择设备模型
        changeEquips(event){
            // console.log(event);     
        },
        //设备信息
        deviceInfo(){
            let cloudConfigId = this.cloudConfigId
            deviceInfo(cloudConfigId)
            .then(res=>{
                let deviceNames = Object.keys(res.data.data)
                let deviceNoPort = Object.values(res.data.data)
                this.deviceNames = deviceNames
                deviceNoPort.forEach(item=>{
                    this.deviceNos.push(item.deviceNo)
                    let ports = []
                    let port = 0
                    for(let i = 0; i < item.portSize; i++){
                        port ++
                        ports.push(port)
                    }
                    this.devicePorts.push(ports)
                })
            })
        },

        //改变设备名称
        changeDeviceNames(event){
            this.form.deviceName = this.deviceNames[event]
            this.deviceIndex = event
            this.form.deviceTypeNo = this.deviceNos[this.deviceIndex]
            this.form.port = this.devicePorts[this.deviceIndex]
        }
    },
    mounted(){
        //获得云id
        this.cloudSelect()
        this.selectCloud()
    }
}
</script>

<style scoped>
.equipmentModel{
    height: 93%;
    width: 100%;
}
.selectType{
    width: 100%;
    height: 8%;
    background: #fff;
    border-radius: 10px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}
.type{
    margin-left: 20px;
    font-weight: bold;
    font-family: '黑体';
}

.submitForm{
    width: 100%;
    min-height: 250px;
    background: #fff;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    box-sizing: border-box;
}
.submitForm >>> .el-form{
    width: 98%;
    height: 90%!important;
}
.el-row{
    display: flex;
    justify-content: space-between;
}
.submitBtn{
    display: flex;
    justify-content: flex-end;
    padding: 0 27px;
}
.submitForm >>> .el-select{
    width: 100%;
}
.equipmentLibrary_table{
    margin-top: 10px;
}
.equipmentLibrary_tit{
    width: 100%;
    height: 60px;
    background: #fff;
    border-radius: 10px 10px 0 0;
    display: flex;
    align-items: center;
    text-indent: 20px;
    font-weight: 550;
    font-family: '黑体';
}
.equipmentLibrary_table >>> .el-table td,
.equipmentLibrary_table >>> .el-table th {
  text-align: center !important;
}
.equipmentLibrary_table >>> th{
  background: #F2F3F7;
}
.delete{
  color: #FB3F4E;
}


.submitForm >>> .el-form-item__label{
    width: 90px!important;
}
.submitForm >>> .el-form-item__content{
    margin-left: 90px!important;
}
.addBtn .add_btn{
    font-size: 35px;
    color: #5673FF;
    padding: 0 10px!important;
    background: #EBEEFF;
}
.addBtn >>> .el-form-item__content{
    margin-left: 7px!important;
    
}
.input_btn{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
}
.inputs1{
    width: 98%;
    display: flex;
    justify-content: space-between;
}
.inputs2{
    width: 95%;
    display: flex;
    justify-content: space-between;
}
.inputWidth1{
    width: 46%;
}
.inputWidth2{
    width: 48%;
}
.delWidth{
    width: 2%;
}
.delWidth >>> .el-form-item__content{
    margin-left: 0!important;
}
.pagination{
    width: 100%;
    display: flex;
    justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/Home/equipmentModel/index.vue